import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardContent,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Button,

  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import loginbg from '../../assets/images/login-bg.svg'
import AppImage from "../../assets/images/IRIS-logo-Transprenet-white.svg"
import StorageService from "../../utils/storageService";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    position: 'relative',
    overflow: 'hidden',
  },
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
     backgroundImage: `url(${loginbg})`
  },
  logoImage:{
    width:'130px'
  },
  content: {
    position: 'relative',
    zIndex: 10,
    minHeight: '100vh',
    display: 'flex',
  },
  leftSection: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
  },
  title: {
    color: 'rgba(19, 57, 132, 1)',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',

    fontSize: '3.6rem',
    fontWeight: 'bold',
    letterSpacing: '0em',


    fontFamily: '"Be Vietnam Pro", sans-serif',
    [theme.breakpoints.down('md')]: {
      fontSize: '3rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.5rem',
    },
  },
  rightSection: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
  },
  card: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: theme.spacing(2),
    boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.25)',
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: 280,
  },
  cardTitle: {
    color: 'rgba(19, 57, 132, 1)',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  formControl: {
    width: '100%',
    marginBottom: theme.spacing(3),
  },
  select: {
    backgroundColor: '#f9fafb',
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#3b82f6',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1e40af',
        borderWidth: 2,
      },
    },
  },
   inputLabel: {
   marginBottom: theme.spacing(1),
    fontWeight: 500,
    color: "rgba(3, 64, 120, 1)",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  button: {
    backgroundColor: '#1e40af',
    color: 'white',
    fontWeight: 600,
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    fontSize: '1rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#1e3a8a',
      transform: 'scale(1.02)',
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
    '&:disabled': {
      backgroundColor: '#9ca3af',
      transform: 'none',
    },
  },
  selectedInfo: {
    marginBottom: theme.spacing(3),
    backgroundColor: '#eff6ff',
    border: '1px solid #bfdbfe',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinner: {
    marginRight: theme.spacing(1),
  },
  // Responsive adjustments
  [theme.breakpoints.down('sm')]: {
    content: {
      flexDirection: 'column',
    },
    leftSection: {
      paddingTop: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      justifyContent: 'center',
      minHeight: '30vh',
    },
    rightSection: {
      paddingRight: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      minHeight: '70vh',
    },
  },
}));

const CLIENTS = [
  { label: "Commercial Vehicle", value: "shareholder-cv" },
  { label: "Passenger Vehicle", value: "shareholder-pv" },
];

export default function ClientSelector({ onSelect }) {
  const classes = useStyles();
  const [selected, setSelected] = useState(CLIENTS[0].value);

  const handleContinue = () => {
    setSelected("selected")
    StorageService.setItem("clientId", selected);
    onSelect(selected);
  };

  return (
    <Box className={classes.root}>
      {/* Background */}
      <Box 
        className={classes.background}
        
      />
      
      {/* Content */}
      <Box className={classes.content}>
        {/* Left Side - Title */}
        <Box className={classes.leftSection}>
          <Typography variant="h2" className={classes.title}>
            <img src={AppImage} alt="IRIS logo" className={classes.logoImage}/>

            {/* IRIS  */}
            <span style={{fontWeight:'400',letterSpacing: '0em',
              fontSize:'50px'
              }}>Portal</span>
          </Typography>
        </Box>
        
        {/* Right Side - Client Selection Form */}
        <Box className={classes.rightSection}>
          <Card className={classes.card} elevation={0}>
            <CardContent>
              {/* <Typography variant="h4" className={classes.cardTitle}>
                Select Client
              </Typography> */}
              
              <Box>
                 
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    value={selected}
                    onChange={(e) => setSelected(e.target.value)}
                    className={classes.select}
                  >
                    {CLIENTS.map((client) => (
                      <MenuItem key={client.value} value={client.value}>
                        {client.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button
                  onClick={handleContinue}
                  fullWidth
                  className={classes.button}
                  size="large"
                >
                  Continue
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}

ClientSelector.propTypes = {
  onSelect: PropTypes.func.isRequired,
};
